<template>
  <div :id="id" class="form-group">
    <label v-once v-if="showLabel && label">{{ label }}</label>
    <input ref="input" @blur="updateInput($event.target.value)" @keydown.enter="updateInput($event.target.value)"
           :type="type" :disabled="isDisabled" class="form-control form-control-sm"/>
  </div>
</template>
<script>
  import isNaN from 'lodash/isNaN'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsFilter,
    name: 'RangeFilter',
    created() {
      this.$store.commit('filters/addFilter', {
        id: this.idFrom,
        field: this.field,
        dependencies: this.dependencies,
        operator: 'gteq',
        default: this.value,
        disabled: this.disabled
      })
      this.$store.commit('filters/addFilter', {
        id: this.idTo,
        field: this.field,
        dependencies: this.dependencies,
        operator: 'lteq',
        default: this.value,
        disabled: this.disabled
      })
    },
    computed: {
      idFrom() {
        return `${this.id}_from`
      },
      idTo() {
        return `${this.id}_to`
      },
      selectedFrom() {
        return this.$store.getters['filters/selectedValue'](this.idFrom)
      },
      selectedTo() {
        return this.$store.getters['filters/selectedValue'](this.idTo)
      },
      isDisabled: {
        get() {
          return this.$store.getters['filters/isDisabled'](this.id)
              || (this.requireParents && this.$store.getters['filters/parentsEmpty'](this.id))
              || this.$store.getters['filters/isDisabled'](this.idFrom)
              || (this.requireParents && this.$store.getters['filters/parentsEmpty'](this.idFrom))
              || this.$store.getters['filters/isDisabled'](this.idTo)
              || (this.requireParents && this.$store.getters['filters/parentsEmpty'](this.idTo))
        },
        set(disabled) {
          this.$store.commit('filters/setDisabled', {id: this.id, disabled})
          this.$store.commit('filters/setDisabled', {id: this.idFrom, disabled})
          this.$store.commit('filters/setDisabled', {id: this.idTo, disabled})
        }
      }
    },
    watch: {
      selected() {
        this.resetInputIfNeeded()
      },
      selectedFrom() {
        this.resetInputIfNeeded()
      },
      selectedTo() {
        this.resetInputIfNeeded()
      }
    },
    methods: {
      updateInput(value) {
        const [from, to] = value.split('-').map(n => n.replace(/\D/g, '')).map(n => parseInt(n)).sort()
        if (from && to) {
          this.$store.commit('filters/setFilter', {[this.id]: null})
          this.$store.commit('filters/setFilter', {[this.idFrom]: from})
          this.$store.commit('filters/setFilter', {[this.idTo]: to})
          this.$refs.input.value = `${from}-${to}`
        } else if (!isNaN(from)) {
          this.$store.commit('filters/setFilter', {[this.id]: from})
          this.$store.commit('filters/setFilter', {[this.idFrom]: null})
          this.$store.commit('filters/setFilter', {[this.idTo]: null})
          this.$refs.input.value = from
        } else {
          this.$store.commit('filters/setFilter', {[this.id]: null})
          this.$store.commit('filters/setFilter', {[this.idFrom]: null})
          this.$store.commit('filters/setFilter', {[this.idTo]: null})
          this.$refs.input.value = ''
        }
      },
      resetInputIfNeeded() {
        if (!this.selected && !this.selectedFrom && !this.selectedTo) {
          this.$refs.input.value = ''
        }
      }
    }
  }
</script>